import { render, staticRenderFns } from "./CreateCommentView.vue?vue&type=template&id=d985ac80&"
import script from "./CreateCommentView.vue?vue&type=script&lang=js&"
export * from "./CreateCommentView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports